if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      //this.form.querySelector('[name=id]').disabled = false;
      this.variantIdInput.disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButtonText = this.submitButton?.querySelector('span');
      if (document.querySelector('cart-drawer')) {
        if(this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }
      }

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      const productVariantId = formData.get('id');
      const deliveryOptions = this.form.querySelector('cm-delivery-options');
      let deliveryAddStarted = false;
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      // Golden delivery prepares this same native request; all other forms keep their original path.
      const request = deliveryOptions
        ? Promise.resolve().then(() => {
            if (typeof deliveryOptions.prepareFormData !== 'function') {
              throw new Error('Delivery options are still loading. Please try again in a moment.');
            }
            return deliveryOptions.prepareFormData(formData);
          }).then(() => {
            deliveryAddStarted = true;
            return fetch(`${routes.cart_add_url}`, config);
          })
        : fetch(`${routes.cart_add_url}`, config);
      request
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: productVariantId, errors: response.description, message: response.message});
            this.handleErrorMessage(deliveryOptions
              ? (response.description || response.message || 'The cart could not be updated.') + ' Please check your cart before trying again.'
              : response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButtonText.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          const additionalVariantId = deliveryOptions && formData.get('items[1][id]');
          if (additionalVariantId && (!Array.isArray(response.items) || !response.items.some((item) => String(item.variant_id || item.id) === String(additionalVariantId)))) {
            throw new Error('The delivery service could not be confirmed.');
          }
          if (deliveryOptions && Array.isArray(response.items)) {
            const primaryItem = response.items.find((item) => String(item.variant_id || item.id) === String(productVariantId));
            if (!primaryItem) throw new Error('The added chair could not be confirmed.');
            response = Object.assign({}, primaryItem, response);
          }
          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: productVariantId, cartData: response});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
          if (deliveryOptions) {
            this.handleErrorMessage(deliveryAddStarted
              ? 'We could not confirm the cart update. Please check your cart before trying again.'
              : (e.message || 'We could not check your delivery choice. Please try again.'));
          }
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          if (deliveryOptions && typeof deliveryOptions.finishSubmission === 'function') {
            deliveryOptions.finishSubmission();
          }
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    toggleSubmitButton(disable = true, text) {
      if (!this.submitButton) return;
      if (disable) {
        this.submitButton.setAttribute('disabled', 'disabled');
        if (text) this.submitButtonText.textContent = text;
      } else {
        this.submitButton.removeAttribute('disabled');
        this.submitButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    get variantIdInput() {
      return this.form.querySelector('[name=id]');
    }
  });
}
